import styled, { createGlobalStyle, keyframes } from "styled-components";
import { Button } from "antd";

// Global styles
export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Poppins', sans-serif;
    background-color: #001a2c;
    min-height: 100vh;
  }
`;

// Animations
export const lineMove = keyframes`
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateY(100%);
    opacity: 0;
  }
`;

export const waveMove = keyframes`
  0%, 100% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Styled Components
export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
`;

export const BackgroundLines = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
`;

export const Line = styled.div`
  position: absolute;
  width: 2px;
  height: 100%;
  background-color: rgba(0, 255, 255, 0.1);
  left: ${(props) => props.$index * 10}%;
  animation: ${lineMove} 2s ease-in-out infinite;
  animation-delay: ${(props) => props.$index * 0.2}s;
`;

export const BackgroundWaves = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0.5;
`;

export const Wave = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0.5;
  background: linear-gradient(45deg, transparent, rgba(0, 255, 255, 0.1));
  animation: ${waveMove} 8s ease-in-out infinite;
  animation-delay: ${(props) => props.$index * -2}s;
`;

export const LoginCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2rem;
  width: 100%;
  max-width: 430px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  position: relative;
  animation: ${fadeIn} 0.5s ease-out forwards;
`;

export const Title = styled.h1`
  text-align: center;
  color: #1a1a1a;
  font-size: 14px;
  text-transform: uppercase;
  margin-bottom: 25px;
  font-weight: 500;
`;
export const HeadingTitle = styled.h1`
  text-align: center;
  color: #1a1a1a;
  font-size: 17px;
  text-transform: uppercase;
  margin-bottom: 10px;
  font-weight: 700;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const InputGroup = styled.div`
  position: relative;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  background-color: #f8f8f8;
  transition: all 0.3s ease;
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: #26b9c8;
    background-color: white;
  }

  &::placeholder {
    color: #999;
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  left: 12px;
  top: 12px;
  color: #26b9c8;
`;

export const ButtonComp = styled(Button)`
  background-color: #26b9c8;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px;
  font-size: 16px;
  font-weight: 500;
  height: 41px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 0.5rem;

  &:hover {
    background-color: #1fa7b5;
  }
`;
